export default "__VITE_ASSET__CTX6gzAP__"